import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
    providedIn: 'root'
})
export class ToastMessageService {
    constructor(private readonly messageService: MessageService) {}

    success(detail: string, life: number = 2000, summary: string = 'Success'): void {
        this.showToast({ type: 'success', detail, life, summary });
    }

    error(detail: string, life: number = 2000, summary: string = 'Error'): void {
        this.showToast({ type: 'error', detail, life, summary });
    }

    warn(detail: string, life: number = 2000, summary: string = 'Warning'): void {
        this.showToast({ type: 'warn', detail, life, summary });
    }

    info(detail: string, life: number = 2000, summary: string = 'Info'): void {
        this.showToast({ type: 'info', detail, life, summary });
    }

    private showToast(toastMessage: any): void {
        this.messageService.add({
            severity: toastMessage.type,
            summary: toastMessage.summary ?? toastMessage.type,
            detail: toastMessage.detail ?? 'Detail',
            life: toastMessage.life ?? 2000,
            key: 'toast-665524a6-0b9d-4079-816f-4fc4fecf0fea'
        });
    }
}
